import React from 'react';
import PropTypes from 'prop-types';
import { ref } from '@dbk-legacy/muster/utils';
import { pure } from '@dbk/ui-react-utils';
import { createContainer } from '@dbk-legacy/muster/react';
import SortingHeader from '../../../../components/common/sorting-header';
import AssetList from '../asset-list';

function PortfolioTable(props) {
  const {
    static: { options },
    portfolio: { assetsSorted },
    changePage,
    messages,
    activeId,
    selectedPorfolioItem,
  } = props;


  if(!selectedPorfolioItem) {
    props.onDataChanged(0, assetsSorted[0]);
  }

  return (
    <div>
      <AssetList
        activeId={activeId}
        selectedPorfolioItem={selectedPorfolioItem}
        columns={options}
        assets={assetsSorted}
        changePage={changePage}
        messages={messages}
      />
    </div>
  );
}

PortfolioTable.propTypes = {
  static: PropTypes.shape({
    columns: SortingHeader.propTypes.columns,
  }).isRequired,
  portfolio: PropTypes.shape({
    assetsSorted: AssetList.propTypes.assets,
  }).isRequired,
  changePage: PropTypes.func,
};

export default createContainer({
  $fragments: {
    portfolio: {
      assetsSorted: {
        $type: 'list',
        $range: {
          offset: 0,
          length: ref('portfolio.assets.length'),
        },
        $node: {
          category: {
            id: true,
            name: true,
          },
          allocation: {
            value: true,
          },
          marketValue: {
            value: true,
          },
          dayChange: {
            percent: true,
            value: true,
          },
        },
      },
    },
    static: {
      options: true,
    },
  },
})(pure(PortfolioTable));
export { PortfolioTable };
